import React, { useState } from "react";
import BarLoader from "react-bar-loader";
import Map from "./Map";
import { ReactSVG } from "react-svg";
import RightLong from "./assets/RightLong.svg";
import { queryMS, queryAddress, states, queryStates } from "./utils";
import { StyledButtonDiv } from "./styles";
import { useDebouncedSearch } from "../../../utils/hooks";
import StyledHome from "../../../utils/styles/StyledHome";
import BG from "./assets/Map Page@2x.png";
import styled from "styled-components";
import BGImageDisplay from "../../../Components/BGImageDisplay/BGImageDisplay";
const variants = {
  closed: {
    opacity: 1,
  },
  open: {
    opacity: 0,
  },
};

const Title = styled.div`
  position: absolute;
  color: white;
  width: 100%;
  height: 100%;
  z-index: 3;
  text-align: center;
  h1 {
    font-size: 48px;
    margin-top: 100px;
  }
`;

const useSearch = () => useDebouncedSearch((text) => queryAddress(text));

const SolarInYourHometown = () => {
  const [loading, setLoading] = useState(false);
  const [proposalData, setProposalData] = useState("");
  const [isError, setIsError] = useState("");
  // eslint-disable-next-line
  const [msNum, setMSNum] = useState("");
  const { inputText, setInputText, searchResults } = useSearch();

  const handleSearch = async () => {
    //reset error each search
    if (isError) setIsError("");
    //declare variable we will set return value to depending on search
    let fetchedData;
    if (!msNum) return;
    //check ms number against database
    setLoading(true);
    try {
      const fetchFirst = await queryMS(msNum);
      const info = fetchFirst.data.data.proposal;
      fetchedData = await queryAddress(
        `${info.Address}${info.City}${info.State}`
      );
      const { lat, lng } = fetchedData.data.results[0].geometry.location;
      const res = await queryStates(info.State);
      setLoading(false);
      return setProposalData({
        lat,
        lng,
        state: info.State,
        allData: res.data.data.gpsMapsByState,
      });
    } catch (err) {
      setLoading(false);
      return setIsError("No Matching MS Number");
    }
  };
  const handleClicked = async (e) => {
    const { lat, lng } = e.geometry.location;
    const state = e.address_components.find((y) =>
      states.includes(y.short_name)
    ).short_name;
    setLoading(true);
    const res = await queryStates(state);
    setLoading(false);
    return setProposalData({
      lat,
      lng,
      state,
      allData: res.data.data.gpsMapsByState,
    });
  };

  return (
    <>
      <StyledHome>
        {!proposalData && (
          <Title>
            <h1>SOLAR IN YOUR HOMETOWN</h1>
          </Title>
        )}
        <StyledButtonDiv
          variants={variants}
          animate={!proposalData ? "closed" : "open"}
        >
          <div className="formDiv">
            <input
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              placeholder="City / State / Zip"
              name="cityStateZip"
            />
            {(loading || searchResults.loading) && (
              <BarLoader color="#00ccff" height="2" />
            )}

            {searchResults.error && (
              <div>Error: {searchResults.error.message}</div>
            )}
            {searchResults.result &&
              !Array.isArray(searchResults.result) &&
              searchResults.result.data.results.length > 0 && (
                <div className="autocompleteBox">
                  {searchResults.result.data.results.map((res, i) => (
                    <div
                      className="autocompleteItem"
                      onClick={() => handleClicked(res)}
                      key={i}
                    >
                      {res.formatted_address}
                    </div>
                  ))}
                </div>
              )}
            {isError && (
              <div style={{ color: "red", textAlign: "center" }}>{isError}</div>
            )}
            <button onClick={() => handleSearch()}>
              <span>VIEW INSTALL MAP</span> <ReactSVG src={RightLong} />
              <ReactSVG src={RightLong} />
            </button>
          </div>
        </StyledButtonDiv>

        {proposalData && <Map info={proposalData} />}
        {!proposalData && <BGImageDisplay bgimage={BG} />}
      </StyledHome>
    </>
  );
};

export default SolarInYourHometown;
